import { lazy } from "react";

const CarManagement = lazy(() => import("./CarManagement"));
const Expenses = lazy(() => import("./Expenses"));
const Profile = lazy(() => import("./Profile"));
const Students = lazy(() => import("./Students"));
const Reports = lazy(() => import("./Reports"));
const Transactions = lazy(() => import("./Transactions"));
const Settings = lazy(() => import("./Settings"));
const RefresherLessons = lazy(() => import("./RefresherLessons"));
const PracticalLessons = lazy(() => import("./PracticalLessons"));
const CourseView = lazy(() => import("./CourseView"));
const Notifications = lazy(() => import("./Notifications"));
const DrivingCourses = lazy(
  () => import("../../pages/landingPage/courses/DrivingCourses")
);
const StudentFilter = lazy(() => import("./studentfilter/StudentFilter"));
const ComputerCourses = lazy(
  () => import("../../pages/landingPage/courses/ComputerCourses")
);
const RefresherCourses = lazy(
  () => import("../../pages/landingPage/courses/RefresherCourses")
);
const StudentGuestCourses = lazy(() => import("./StudentGuestCourses"));
const Lessons = lazy(() => import("./Lessons"));
export {
  CarManagement,
  Expenses,
  Profile,
  Students,
  Reports,
  Transactions,
  Settings,
  RefresherLessons,
  PracticalLessons,
  CourseView,
  DrivingCourses,
  ComputerCourses,
  RefresherCourses,
  StudentGuestCourses,
  Lessons,
  Notifications,
  StudentFilter,
};
